"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "ReportsLogo___StyledSvg",
  componentId: "sig2cl-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function ReportsLogo(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M450 125c0 11.592-9.387 21-21 21v210h21v42H261v42h-42v-42H30v-42h21V146c-11.592 0-21-9.408-21-21V62c0-11.592 9.408-21 21-21h378c11.613 0 21 9.408 21 21v63zm-63 231V146H93v210h294zM72 83v21h336V83H72zm105 231c-34.776 0-63-28.203-63-63 0-34.776 28.224-63 63-63v63h63c0 34.797-28.203 63-63 63zm21-147c34.797 0 63 28.224 63 63h-63v-63zm168 0v42h-63v-42h63zm0 63v42h-84v-42h84zM240 335v-42h126v42H240z"
  }));
}

var _default = ReportsLogo;
exports["default"] = _default;